import { render, staticRenderFns } from "./vps.html.vue?vue&type=template&id=660086ee"
import script from "./vps.html.vue?vue&type=script&lang=js"
export * from "./vps.html.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/vps/index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/vps/index.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports